import { salesDb } from "@/utils/localDb";
import { v4 as uuidv4 } from "uuid";

export const useSales = () => {
  const saveSaleOffline = async (saleData: any) => {
    const id = uuidv4(); // Generate unique id
    await salesDb.setItem(id, saleData);
  };

  const getAllOfflineSales = async () => {
    const sales: any[] = [];
    await salesDb.iterate((value) => {
      sales.push(value);
    });
    return sales;
  };

  const clearOfflineSales = async () => {
    await salesDb.clear();
  };

  return { saveSaleOffline, getAllOfflineSales, clearOfflineSales };
};
